import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ChartOfAccountsTemplateRow } from "../chartOfAccountsTemplatesViewConfig";

export const ChartOfAccountsTemplateDescriptionCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ChartOfAccountsTemplateRow, unknown>) => {
        const { description } = row.original;

        return (
            <ViewTableCell>
                {description ? (
                    <span className="text-secondary text-truncate">
                        {description}
                    </span>
                ) : (
                    <EmptyValue />
                )}
            </ViewTableCell>
        );
    },
);
